import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { RequestPasswordResetParams, RequestPasswordResetResponse } from '../types';
import env from '@/env';
import { jsonifyEscape } from '@/core';

export const requestPasswordReset = async ({
  email,
}: RequestPasswordResetParams): Promise<RequestPasswordResetResponse> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auth/request-user-reset-password`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    }
  );

  if (!fetchResponse.ok) {
    const error = JSON.parse(jsonifyEscape(await fetchResponse.text())) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as RequestPasswordResetResponse;
  return response;
};
